import { Trans, useTranslation } from 'react-i18next';
import PageHeader from 'components/pageHeader/PageHeader';
import { NavLink } from 'react-router-dom';
import ManageLanguagesButton from 'pages/automations/common/manageLanguages/ManageLanguagesButton';
import { UsageType } from 'models/automation/Common';
import HeaderSearchField from '../search/HeaderSearchField';
import AddCustomTemplatesButton from './AddCustomTemplatesButton';
import { CustomTemplatesTabHeaderButtons } from './CustomTemplatesTabHeader.styles';

const CustomTemplatesTabHeader = () => {
  const { t } = useTranslation();

  return (
    <PageHeader
      title={t('pageAutomations.customTemplates.title')}
      subtitle={
        <Trans
          i18nKey="pageAutomations.customTemplates.subtitle"
          components={{
            link1: (
              <NavLink
                aria-label={t('pageAutomations.tabNames.triggers')}
                to="../triggers"
              />
            ),
            link2: (
              <a
                aria-label="Hostfully documentation"
                href="https://help.hostfully.com/en/articles/1674808-create-custom-templates-and-triggers"
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      }
      noDivider
      buttons={
        <ManageLanguagesButton
          usageType={UsageType.CUSTOM}
          hideAutoTranslation
        />
      }
    >
      <CustomTemplatesTabHeaderButtons>
        <HeaderSearchField />
        <AddCustomTemplatesButton />
      </CustomTemplatesTabHeaderButtons>
    </PageHeader>
  );
};

export default CustomTemplatesTabHeader;
